export const getLocalStorage = (name) => {
    return localStorage ? localStorage.getItem(name) : {};
}

export const setLocalStorage = (name, value) => {
    localStorage.setItem(name, value);
}
